import React, { useEffect, useState } from 'react'
import { FaRegListAlt } from 'react-icons/fa'
import { Image } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { compareUser } from '../../../utilities/utilities'
import "./lookingFor.css"
import { IoMdCheckmarkCircle } from "react-icons/io"
import { RxCrossCircled } from 'react-icons/rx'
import key from '../../../key'

function LookingFor({ match, points }) {
    const { user } = useSelector(state => state.user)
    const [showPhoto, setShowPhoto] = useState("show")

    useEffect(() => {
        if (match?.privacy.photo === "hide") {
            setShowPhoto("hide")
        } else if (match?.privacy.photo === "like" && !compareUser(user._id, match.acceptedInvites)) {
            setShowPhoto("like")
        } else if (match?.privacy.photo === "premium" && user.userStatus.membership.membershipType === "Free") {
            setShowPhoto("premium")
        } else if (match?.privacy.photo === "likeAndPremium" && ((user.userStatus.membership.membershipType === "Free") || compareUser(user._id, match.acceptedInvites))) {
            setShowPhoto("premium")
        } else if (match?.privacy.photo === "likeAndPremium" && ((user.userStatus.membership.membershipType !== "Free") || !compareUser(user._id, match.acceptedInvites))) {
            setShowPhoto("like")
        }
        //eslint-disable-next-line
    }, []);
    return (
        <>
            <div className='d-flex'>
                <FaRegListAlt className='match-detail-icon' />
                <div className='match-detail-title'>What she is Looking For </div>
            </div>
            <div className='match-detail-info'>
                <div className='match-detail-preferences-header d-flex justify-content-between'>
                    <div>
                        {showPhoto === "show" && match?.photos[0] ? <Image src={`${key}/images/${match?.photos[0].url}`} className='match-preferences-photo' /> : <Image src="https://www.allianceplast.com/wp-content/uploads/no-image-1024x1024.png" className='match-preferences-photo' />}
                        <div className='text-center'>Her Prefrences</div>
                    </div>

                    <div className='d-flex fs-6 align-items-center'>
                        <span className='matching-preferences-message'> You match {points.points}/14 of preferences</span>
                    </div>
                    <div>
                        {user?.photos[0] ? <Image src={`${key}/images/${user?.photos[0]?.url}`} className='match-preferences-photo' /> : <Image src="https://www.allianceplast.com/wp-content/uploads/no-image-1024x1024.png" className='match-preferences-photo' />}
                        <div className='text-center'>You Match</div>
                    </div>
                </div>
                <div style={{ display: "block" }}>
                    <ul className='lists'>
                        <li className='list-item'>
                            <div className="d-flex justify-content-between">
                                <div>
                                    <div className='list-item-title'>Age</div>
                                    <div className='list-item-desc'>
                                        {match?.partnerPreferences?.age ==="-" ? "All": match?.partnerPreferences?.age } Years
                                    </div>
                                </div>
                                <div className='list-item-value'>
                                    {points?.categories?.age ? <IoMdCheckmarkCircle style={{ color: "green" }} size={25} /> : <RxCrossCircled style={{ color: "red" }} size={25} />}
                                </div>
                            </div>
                        </li>
                        <li className='list-item'>
                            <div className="d-flex justify-content-between">
                                <div>
                                    <div className='list-item-title'>Height</div>
                                    <div className='list-item-desc'>
                                        {match?.partnerPreferences?.height ==="-" ? "All": match?.partnerPreferences?.height }
                                    </div>
                                </div>
                                <div className='list-item-value'>
                                    {points?.categories?.height ? <IoMdCheckmarkCircle style={{ color: "green" }} size={25} /> : <RxCrossCircled style={{ color: "red" }} size={25} />}
                                </div>
                            </div>
                        </li>
                        <li className='list-item'>
                            <div className="d-flex justify-content-between">
                                <div>
                                    <div className='list-item-title'>Annual Income</div>
                                    <div className='list-item-desc'>
                                        {!match?.partnerPreferences?.annualIncome[0] ? "Open to All": `${match?.partnerPreferences?.annualIncome} ` }
                                    </div>
                                </div>
                                <div className='list-item-value'>
                                    {points?.categories?.annualIncome ? <IoMdCheckmarkCircle style={{ color: "green" }} size={25} /> : <RxCrossCircled style={{ color: "red" }} size={25} />}
                                </div>
                            </div>
                        </li>
                        <li className='list-item'>
                            <div className="d-flex justify-content-between">
                                <div>
                                    <div className='list-item-title'>Country Living In</div>
                                    <div className='list-item-desc'>
                                        {!match?.partnerPreferences?.countryLiving[0] ? "Open to All": `${match?.partnerPreferences?.countryLiving}, ` }
                                    </div>
                                </div>
                                <div className='list-item-value'>
                                    {points?.categories?.countryLiving ? <IoMdCheckmarkCircle style={{ color: "green" }} size={25} /> : <RxCrossCircled style={{ color: "red" }} size={25} />}
                                </div>
                            </div>
                        </li>
                        <li className='list-item'>
                            <div className="d-flex justify-content-between">
                                <div>
                                    <div className='list-item-title'>City Living</div>
                                    <div className='list-item-desc'>
                                        {!match?.partnerPreferences?.cityLiving[0] ? "Open to All": `${match?.partnerPreferences?.cityLiving}, ` }
                                    </div>
                                </div>
                                <div className='list-item-value'>
                                    {points?.categories?.cityLiving ? <IoMdCheckmarkCircle style={{ color: "green" }} size={25} /> : <RxCrossCircled style={{ color: "red" }} size={25} />}
                                </div>
                            </div>
                        </li>
                        <li className='list-item'>
                            <div className="d-flex justify-content-between">
                                <div>
                                    <div className='list-item-title'>Country Grew Up In</div>
                                    <div className='list-item-desc'>
                                        {!match?.partnerPreferences?.grewUpIn[0] ? "Open to All": `${match?.partnerPreferences?.grewUpIn}, ` }
                                    </div>
                                </div>
                                <div className='list-item-value'>
                                    {points?.categories?.grewUpIn ? <IoMdCheckmarkCircle style={{ color: "green" }} size={25} /> : <RxCrossCircled style={{ color: "red" }} size={25} />}
                                </div>
                            </div>
                        </li>
                        <li className='list-item'>
                            <div className="d-flex justify-content-between">
                                <div>
                                    <div className='list-item-title'>Religion</div>
                                    <div className='list-item-desc'>
                                        {!match?.partnerPreferences?.religion[0] ? "Open to All": `${match?.partnerPreferences?.religion}, ` }
                                    </div>
                                </div>
                                <div className='list-item-value'>
                                    {points?.categories?.religion ? <IoMdCheckmarkCircle style={{ color: "green" }} size={25} /> : <RxCrossCircled style={{ color: "red" }} size={25} />}
                                </div>
                            </div>
                        </li>
                        <li className='list-item'>
                            <div className="d-flex justify-content-between">
                                <div>
                                    <div className='list-item-title'>Community</div>
                                    <div className='list-item-desc'>
                                        {!match?.partnerPreferences?.community[0] ? "Open to All": `${match?.partnerPreferences?.community}, ` }
                                    </div>
                                </div>
                                <div className='list-item-value'>
                                    {points?.categories?.community ? <IoMdCheckmarkCircle style={{ color: "green" }} size={25} /> : <RxCrossCircled style={{ color: "red" }} size={25} />}
                                </div>
                            </div>
                        </li>
                        <li className='list-item'>
                            <div className="d-flex justify-content-between">
                                <div>
                                    <div className='list-item-title'>Diet</div>
                                    <div className='list-item-desc'>
                                        {!match?.partnerPreferences?.diet[0] ? "Open to All": `${match?.partnerPreferences?.diet}, ` }
                                    </div>
                                </div>
                                <div className='list-item-value'>
                                    {points?.categories?.diet ? <IoMdCheckmarkCircle style={{ color: "green" }} size={25} /> : <RxCrossCircled style={{ color: "red" }} size={25} />}
                                </div>
                            </div>
                        </li>
                        <li className='list-item'>
                            <div className="d-flex justify-content-between">
                                <div>
                                    <div className='list-item-title'>Marital Status</div>
                                    <div className='list-item-desc'>
                                        {!match?.partnerPreferences?.maritalStatus[0] ? "Open to All": `${match?.partnerPreferences?.maritalStatus}, ` }
                                    </div>
                                </div>
                                <div className='list-item-value'>
                                    {points?.categories?.maritalStatus ? <IoMdCheckmarkCircle style={{ color: "green" }} size={25} /> : <RxCrossCircled style={{ color: "red" }} size={25} />}
                                </div>
                            </div>
                        </li>
                        <li className='list-item'>
                            <div className="d-flex justify-content-between">
                                <div>
                                    <div className='list-item-title'>Mother Tongue</div>
                                    <div className='list-item-desc'>
                                        {!match?.partnerPreferences?.motherTongue[0] ? "Open to All": `${match?.partnerPreferences?.motherTongue}, ` }
                                    </div>
                                </div>
                                <div className='list-item-value'>
                                    {points?.categories?.motherTongue ? <IoMdCheckmarkCircle style={{ color: "green" }} size={25} /> : <RxCrossCircled style={{ color: "red" }} size={25} />}
                                </div>
                            </div>
                        </li>
                        <li className='list-item'>
                            <div className="d-flex justify-content-between">
                                <div>
                                    <div className='list-item-title'>Education</div>
                                    <div className='list-item-desc'>
                                        {!match?.partnerPreferences?.qualification[0] ? "Open to All": `${match?.partnerPreferences?.qualification}, ` }
                                    </div>
                                </div>
                                <div className='list-item-value'>
                                    {points?.categories?.qualification ? <IoMdCheckmarkCircle style={{ color: "green" }} size={25} /> : <RxCrossCircled style={{ color: "red" }} size={25} />}
                                </div>
                            </div>
                        </li>
                        <li className='list-item'>
                            <div className="d-flex justify-content-between">
                                <div>
                                    <div className='list-item-title'>Occupation</div>
                                    <div className='list-item-desc'>
                                        {!match?.partnerPreferences?.occupation[0] ? "Open to All": `${match?.partnerPreferences?.occupation}, ` }
                                    </div>
                                </div>
                                <div className='list-item-value'>
                                    {points?.categories?.occupation ? <IoMdCheckmarkCircle style={{ color: "green" }} size={25} /> : <RxCrossCircled style={{ color: "red" }} size={25} />}
                                </div>
                            </div>
                        </li>
                        <li className='list-item'>
                            <div className="d-flex justify-content-between">
                                <div>
                                    <div className='list-item-title'>Working With</div>
                                    <div className='list-item-desc'>
                                        {!match?.partnerPreferences?.workingWith[0] ? "Open to All": `${match?.partnerPreferences?.workingWith}, ` }
                                    </div>
                                </div>
                                <div className='list-item-value'>
                                    {points?.categories?.workingWith ? <IoMdCheckmarkCircle style={{ color: "green" }} size={25} /> : <RxCrossCircled style={{ color: "red" }} size={25} />}
                                </div>
                            </div>
                        </li>
                        <li className='list-item'>
                            <div className="d-flex justify-content-between">
                                <div>
                                    <div className='list-item-title'>Smoking</div>
                                    <div className='list-item-desc'>
                                        {!match?.partnerPreferences?.smoke[0] ? "Open to All": `${match?.partnerPreferences?.smoke}, ` }
                                    </div>
                                </div>
                                <div className='list-item-value'>
                                    {points?.categories?.smoke ? <IoMdCheckmarkCircle style={{ color: "green" }} size={25} /> : <RxCrossCircled style={{ color: "red" }} size={25} />}
                                </div>
                            </div>
                        </li>
                        <li className='list-item'>
                            <div className="d-flex justify-content-between">
                                <div>
                                    <div className='list-item-title'>Drinking</div>
                                    <div className='list-item-desc'>
                                        {!match?.partnerPreferences?.drink[0] ? "Open to All": `${match?.partnerPreferences?.drink}, ` }
                                    </div>
                                </div>
                                <div className='list-item-value'>
                                    {points?.categories?.drink ? <IoMdCheckmarkCircle style={{ color: "green" }} size={25} /> : <RxCrossCircled style={{ color: "red" }} size={25} />}
                                </div>
                            </div>
                        </li>
                        <li className='list-item'>
                            <div className="d-flex justify-content-between">
                                <div>
                                    <div className='list-item-title'>Drugs</div>
                                    <div className='list-item-desc'>
                                        {!match?.partnerPreferences?.drug[0] ? "Open to All": `${match?.partnerPreferences?.drug}, ` }
                                    </div>
                                </div>
                                <div className='list-item-value'>
                                    {points?.categories?.drug ? <IoMdCheckmarkCircle style={{ color: "green" }} size={25} /> : <RxCrossCircled style={{ color: "red" }} size={25} />}
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </>
    )
}

export default LookingFor